module.exports = __webpack_public_path__ + "static/media/hoi-an-vietnam.b131f923.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photography/hoi-an-vietnam.jpg
// module id = 156
// module chunks = 0